@if (isVideoRecording && is2ndDevice) {
  <div>
    @if (!isUploading) {
      <div
        class="text-center"
        >
        <div
          class="btn btn-danger text-center btn-sm mt-3"
          (click)="stopAndUpload()"
          i18n="@@uploadVideoRecording"
        >Aufnahme hochladen</div>
      </div>
    }
  </div>
}

<div [ngClass]="{'d-none':isUploading || !isVideoRecording, 'mt-3': is2ndDevice}">
  <video
    #videoElement
    [muted]="'muted'"
    style="max-width: 900px;"
    class="w-100 m-auto"
    playsinline
    [src]="(!isVideoRecording && videoBlobUrl) ? videoBlobUrl : null"
  ></video>
</div>

<table
  width="100%"
  height="100%"
  >
  <tr style="height: 0;">
    <td class="p-3">
      @if (!isVideoRecording && !videoBlobUrl && !isUploading) {
        <div>
          @if (is2ndDevice) {
            <p
              i18n="@@stopVideoRecordingInformationIos"
              >
                    Bitte drücken Sie zur Beendigung des Videos auf den “Aufnahme hochladen” - Button am oberen
                    Bildschirmrand.
                    Starten Sie die Aufnahme, indem Sie auf das Kamerasymbol klicken.
                </p>
          }
          @if (!is2ndDevice) {
            <p
              i18n="@@stopVideoRecordingInformation"
              >Nach dem Stoppen der Aufnahme startet der Upload automatisch.
                </p>
          }
        </div>
      }
      @if (this.isUploading) {
        <div
          class="text-center"
          >
          @if (is2ndDevice) {
            <img
              alt="Upload"
              src="assets/icons/video-upload-line.svg"
              height="50px"
              >
          }
          @if (!is2ndDevice) {
            <img
              alt="Upload"
              src="assets/icons/video-upload-line-black.svg"
              height="50px"
              >
          }
          <h1>{{uploadProgress}}%</h1><br>
          @if (retryCount > 0 && this.retryCount != this.maxRetrys) {
            <small>
              <b>Status: </b>{{uploadStatus}} @if (this.retryCount > 0) {
              <span>({{this.retryCount}} /
              {{this.maxRetrys}})</span>
            }
          </small>
        }
      </div>
    }
  </td>
</tr>
<tr>
  <td class="p-3">
    @if (!isVideoRecording && !videoBlobUrl && !isUploading) {
      <div>
        @if (this.is2ndDevice) {
          <div
            class="toller-button"
            >
            <div
              class="toller-button-inhalt"
              (click)="startVideoRecording()"
              >
              <img
                alt="Aufnahme starten"
                src="assets/icons/vidicon-fill.svg"
                style="height: 40vw;"
                >
            </div>
          </div>
        }
        @if (!this.is2ndDevice) {
          <div>
            <div
              class="btn btn-danger btn-sm"
              (click)="startVideoRecording()"
              i18n="@@videoStartRecording"
            >Aufnahme starten</div>
          </div>
        }
      </div>
    }
    @if (isVideoRecording && !is2ndDevice) {
      <div>
        @if (!isUploading) {
          <div>
            <div
              class="btn btn-danger text-center btn-sm"
              (click)="stopAndUpload()"
              >
              <span
                class="text-center"
                i18n="@@stopAndUploadVideoRecording"
                >
                            Aufnahme stoppen und hochladen
                        </span>
            </div>
          </div>
        }
      </div>
    }
    @if (this.isUploading) {
      <div
        class="text-center"
        >
        @if (uploadProgress == 100) {
          <div>
            <div class="result-icon">
              <img
                alt="Aufnahme abgeschlossen"
                src="assets/icons/emotion-happy-line.svg"
                [ngStyle]="{'max-width': !is2ndDevice ? '200px':'none'}"
                >
            </div>
            <small i18n="@@videoSuccessfullyUploaded">Erfolgreich hochgeladen!</small>
          </div>
        }
        @if (this.retryCount == this.maxRetrys) {
          <div>
            <div class="result-icon">
              <img
                src="assets/icons/emotion-sad-line.svg"
                [ngStyle]="{'max-width': !is2ndDevice ? '200px':'none'}"
                >
            </div>
            <small i18n="@@videoUploadFailed">Hochladen fehlgeschlagen!</small><br>
            <div
              class="btn btn-primary btn-sm"
              (click)="retryUpload()"
              i18n="@@retryAgain"
            >Erneut versuchen</div>
          </div>
        }
      </div>
    }
  </td>
</tr>
</table>